import { useAnswerMode } from '@/data/hook/question/answers/useAnswerMode';
import { QuizAnswerCreateDTO } from '@/models/Answer';
import QuizAnswerMedia from './QuizAnswerMedia';
import QuizAnswerText from './QuizAnswerText';

type QuizAnswerItemProps = {
  answer: QuizAnswerCreateDTO;
  initialEditing?: boolean;
  onUpdateText: (text: string) => void;
  onUpdateMedia: (file: File | string, altText?: string) => void;
  onToggleCorrect: () => void;
  onDelete: () => void;
};

export default function QuizAnswerItem({
  answer,
  initialEditing,
  onUpdateText,
  onUpdateMedia,
  onToggleCorrect,
  onDelete,
}: QuizAnswerItemProps) {
  const {
    mode,
    isEditing,
    handleSwitchToMedia,
    handleSwitchToText,
    handleStartEdit,
    handleFinishEdit,
  } = useAnswerMode({ mediaFile: answer.mediaFile, initialEditing });

  if (mode === 'media') {
    return (
      <QuizAnswerMedia
        answer={answer}
        isEditing={isEditing}
        onStartEdit={handleStartEdit}
        onFinishEdit={handleFinishEdit}
        onUpdateMedia={onUpdateMedia}
        onSwitchToText={handleSwitchToText}
        onToggleCorrect={onToggleCorrect}
        onDelete={onDelete}
      />
    );
  }

  return (
    <QuizAnswerText
      answer={answer}
      isEditing={isEditing}
      onStartEdit={handleStartEdit}
      onFinishEdit={handleFinishEdit}
      onUpdateText={onUpdateText}
      onSwitchToMedia={handleSwitchToMedia}
      onToggleCorrect={onToggleCorrect}
      onDelete={onDelete}
    />
  );
}
